import React, { Component } from 'react';
import VehicleSpec from './vehicleSpec';
import ResultList from './resultList';
import ResultsNotes from './resultsNotes';
import Disclaimer from '../disclaimer';
import Axios from 'axios';
import { translate } from 'react-i18next';
import store from '../../store';
import { storeResults, storeSelected } from '../../actions';
const Fragment = React.Fragment;

class Results extends Component {
  state = {};

  componentDidMount() {
    window.scrollTo(0, 0);
    window.parent.postMessage(JSON.stringify({ value: 0 }), '*');

    const { i18n, t, equipment, cvl } = this.props;
    const url = store.getState().content.url;
    const token = store.getState().content.token;
    const endPoint = cvl ? '/api/cvl/equipment' : '/api/pvl/equipment';
    const params = {
      culture: t('config.CULTURE'),
      equipment: equipment.key,
    };

    params.lob = 'b2b';

    if (i18n.language === 'is') {
      params.lob = 'b2c';
    }

    Axios.get(url + endPoint, {
      params: params,
      headers: { token: token },
    })
      .then((response) => {
        store.dispatch(storeResults(response.data));
        this.setState({
          equipment: response.data,
        });
      })
      .catch((error) => {
        console.warn(error);
      });

    this.updateHeader();
  }

  backToSearch = () => {
    const { backToSearch, selectedFamily, cvl } = this.props;
    store.dispatch(storeSelected(null));
    backToSearch(selectedFamily, cvl);
  };

  updateHeader = () => {
    this.props.updateHeader('results');
  };

  render() {
    const { selectedFamily } = this.props;
    const { equipment } = this.state;

    const content = (
      <Fragment>
        <VehicleSpec
          backToSearch={this.backToSearch}
          selectedFamily={selectedFamily}
          equipment={equipment}
        />
        <ResultList
          equipment={equipment}
          selectedFamily={selectedFamily}
          showFilter
          showProductLinks
        />
        {equipment && equipment.application_notes ? <ResultsNotes equipment={equipment} /> : ''}
      </Fragment>
    );

    return (
      <section className="results-page">
        {equipment ? content : ''}
        <Disclaimer />
      </section>
    );
  }
}

export default translate('translations')(Results);



// WEBPACK FOOTER //
// ./src/components/results/results.js